import { useState } from 'react';

const getCountries = (channelPickerItems, currentCountry, geoIpCountry) => {
    var countries = channelPickerItems.filter(x => x.CountryCode == geoIpCountry)
    if(countries.length > 0) {
        return countries[0];
    }
    
    return channelPickerItems.filter(x => x.CountryId == currentCountry)[0];
}
const getAsValueLabelList = (countriesList) => {
    return countriesList.Channels.map((item) => (
        {
            label: item.ChannelName,
            value: item.ChannelId
        }));
}
const getLanguageList = (channelPickerItems, currentCountry, geoIpCountry) => {
    return getAsValueLabelList(getCountries(channelPickerItems, currentCountry, geoIpCountry));
}
export function useLanguageList(channelPickerItems, currentCountry, geoIpCountry) {
    const [languageList, setLanguageList] = useState(getLanguageList(channelPickerItems, currentCountry, geoIpCountry));
    const callback = (channelPickerItems, currentCountry) => {
        const languageList = getLanguageList(channelPickerItems, currentCountry, "");
        setLanguageList(languageList);
        return languageList;
    };

    return [languageList, callback];
}